import {getApiHostUrl} from "../settings"

const HEADERS_GET = {
    "Accept": "application/json",
}

const HEADERS_POST = {
    "Accept": "application/json",
    "Content-Type": "application/json"
}

export const apiCatalog = (lang) => {

    const request = new Request(
        getApiHostUrl() + `api/configurable-products?lang=${lang}`,
        {
            method: "GET",
            headers: HEADERS_GET
        }
    )
    return fetch(request)
        .then(response => handleJsonResponse(response, "api: configurable-products error"))
}

export const apiRoomParameters = () => {

    const request = new Request(
        getApiHostUrl() + "api/room-parameters",
        {
            method: "GET",
            headers: HEADERS_GET
        }
    )
    return fetch(request)
        .then(response => handleJsonResponse(response, "api: room-parameters error"))
}

export const apiRooms = (roomSetup, roomId) => {
    const request = new Request(
        getApiHostUrl() + (roomId ? `api/rooms/${roomId}` : "api/rooms"),
        {
            method: roomId ? "PUT" : "POST",
            headers: HEADERS_POST,
            body: JSON.stringify(roomSetup)
        }
    )
    return fetch(request)
        .then(response => handleJsonResponse(response, "api: room error"))
}

export const apiExpertSuggestions = (roomId, lang) => {
    const request = new Request(
        getApiHostUrl() + `api/expert-suggestions/${roomId}?&lang=${lang}`,
        {
            method: "GET",
            headers: HEADERS_GET
        }
    )
    return fetch(request)
        .then(response => handleJsonResponse(response, "api: expert-suggestions error"))
}

export const apiSolutionSave = (roomId, planId, name, products, lang) => {

    const url = planId
        ? getApiHostUrl() + `api/plannings/${planId}?lang=${lang}`
        : getApiHostUrl() + `api/plannings`

    const request = new Request(
        url,
        {
            method: planId ? "PUT" : "POST",
            headers: HEADERS_POST,
            body: JSON.stringify({
                roomId: roomId,
                id: planId,
                name: name,
                products: products,
            })
        }
    )

    return fetch(request)
        .then(response => handleJsonResponse(response, "api: solution error"))
}

export const apiSolutionLoad = (planId, lang) => {
    const request = new Request(
        getApiHostUrl() + `api/plannings/${planId}?lang=${lang}`,
        {
            method: "GET",
            headers: HEADERS_GET
        }
    )

    return fetch(request)
        .then(response => handleJsonResponse(response, "api: solution error"))
}

export const apiSavedRoomsSave = (activePlanningId, planningIds, panningName, code = null) => {
    const request = new Request(
        getApiHostUrl() + (code ? `api/saved-rooms/${code}` : `api/saved-rooms`),
        {
            method: code ? "PUT" : "POST",
            headers: HEADERS_POST,
            body: JSON.stringify({
                code: code,
                planningId: activePlanningId,
                name: panningName,
                planningIds: planningIds,
                keepCode: code ? true : false
            })
        }
    )

    return fetch(request)
        .then(response => handleJsonResponse(response, "api: solution save error"))
}

export const apiSavedRoomsLoad = (roomCode) => {
    const request = new Request(
        getApiHostUrl() + `api/saved-rooms/${roomCode.replace(/\s/g, "")}`,
        {
            method: "GET",
            headers: HEADERS_GET,
        }
    )

    return fetch(request)
        .then(response => handleJsonResponse(response, "api: solution load error"))
}

export const apiShareRoom = (data) => {
    const request = new Request(
        getApiHostUrl() + "api/share-rooms",
        {
            method: "POST",
            headers: HEADERS_POST,
            body: JSON.stringify(data)
        }
    )

    return fetch(request)
        .then(response => handleJsonResponse(response, "api: share solution error"))
}

export const apiCart = (cartId, planningId, lang, country) => {
    const url = cartId
        ? getApiHostUrl() + `api/carts/${cartId}?lang=${lang}`
        : getApiHostUrl() + `api/carts?lang=${lang}`

    const request = new Request(
        url,
        {
            method: cartId ? "PUT" : "POST",
            headers: HEADERS_POST,
            body: JSON.stringify({
                planningId: planningId,
                countryCode: country
            })
        }
    )

    return fetch(request)
        .then(response => handleJsonResponse(response, "api: cart error"))
}

export const apiPrivacyInfo = (lang) => {
    const request = new Request(
        `assets/content/privacy-${lang}.html`,
        {
            method: "GET",
        }
    )

    return fetch(request)
        .then(response => response.text())
}

export const apiTranslation = () => {
    const request = new Request(
        "assets/translation.json",
        {
            method: "GET",
            headers: HEADERS_GET,
        }
    )

    return fetch(request)
        .then(response => handleJsonResponse(response, "api: translation error"))
}

export const apiShipping = () => {
    const request = new Request(
        "assets/shipping.json",
        {
            method: "GET",
            headers: HEADERS_GET,
        }
    )

    return fetch(request)
        .then(response => handleJsonResponse(response, "api: shipping error"))
}

export const apiExitIntentLogs = (email, code) => {
    const request = new Request(
        getApiHostUrl() + "api/exit-intent-logs",
        {
            method: "POST",
            headers: HEADERS_POST,
            body: JSON.stringify({
                email: email,
                roomCode: code
            })
        }
    )

    return fetch(request)
        .then(response => handleJsonResponse(response, "api: exit intent logs error"))
}

const handleJsonResponse = (response, errorMessage = null) => {

    if (response.ok) return response.json()

    return response.text().then(error => {
        try {
            error = JSON.parse(error)
            return new Promise((_resolve, reject) => {
                const title = error?.title ?? "Error"
                const detail = error?.detail ?? (errorMessage ?? "API Response Error")
                reject({title, detail, message: detail})
            })
        } catch {
            return new Promise((_resolve, reject) => {
                const title = "Error"
                const detail = errorMessage ?? "API Response Error"
                reject({title, detail, message: detail})
            })
        }
    })
}

const apiRequestQuote = {
    allowedKeys: null,
    allowedValues: null,
    postCustomerData: null
}

apiRequestQuote.allowedKeys = {
    customerType: 'type',
    email: 'email',
    phone: 'phoneNumber',
    firstname: 'firstname',
    lastname:  'lastname',
    street: 'street',
    housenumber:  'houseNumber',
    postalcode: 'postcode',
    city:  'city',
    country: 'country',
    roomCode:  'roomCode',
    companyName: 'company',
    actioncode: "actioncode",
    usermessage: "usermessage"
}

apiRequestQuote.allowedValues = {
    customerType: {
        private: 'private',
        corporate: 'company'
    }
}

apiRequestQuote.postCustomerData = async (data) => {
    const request = new Request(
        getApiHostUrl() + "api/quotation-requests",
        {
            method: "POST",
            headers: HEADERS_POST,
            body: JSON.stringify(data)
        }
    )
        
    const logErrorInConsole = (response) => {
        handleJsonResponse(response, "api: request quote error")
    }

    const response = await fetch(request)
    
    if (!response.ok) {
        logErrorInConsole(response)
    }

    return response.ok
}

export {apiRequestQuote}